export default __webpack_public_path__ + "psn-feedback-widget.c5224a474ea2f55f5b7c6e67f5abbc31.css";